import { Colors } from "Themes/Colors";

const styles = {
  container: {
    backgroundColor: Colors.mainColor,
    borderTop: "solid 2px gray",
    display: "flex",
    marginTop: "15%",
    padding: 20
  },
  textContainer: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    paddingRight: 20,
  },
  text: {
    textAlign: "right",
    color: "white",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    },
    border: "solid 2px white",
    borderRadius: 10,
    padding: 10
  }
};

export default styles;
